(function () {
  const liquidSorts = new Set([
    'title-ascending',
    'title-descending',
    'price-ascending',
    'price-descending',
    'created-ascending',
    'created-descending',
  ]);
  let requestId = 0;

  function productKey(href) {
    if (!href) return '';
    const path = href.split('?')[0];
    const parts = path.split('/').filter(Boolean);
    try {
      return decodeURIComponent(parts[parts.length - 1] || '');
    } catch (error) {
      return parts[parts.length - 1] || '';
    }
  }

  function keysFrom(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = doc.getElementById('product-grid');
    if (!grid) return [];
    const keys = [];
    grid.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const key = productKey(link.getAttribute('href'));
      if (key && keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function reorderGrid(grid, keys) {
    const items = Array.prototype.filter.call(grid.children, (el) => el.tagName === 'LI');
    const byKey = new Map();
    items.forEach((item) => {
      const link = item.querySelector('a[href*="/products/"]');
      const key = productKey(link && link.getAttribute('href'));
      if (key && !byKey.has(key)) byKey.set(key, item);
    });
    const ordered = [];
    keys.forEach((key) => {
      const item = byKey.get(key);
      if (!item) return;
      ordered.push(item);
      byKey.delete(key);
    });
    byKey.forEach((item) => ordered.push(item));
    ordered.forEach((item) => grid.appendChild(item));
  }

  function selectSort(value) {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      const hasValue = Array.prototype.some.call(select.options, (option) => option.value === value);
      if (hasValue) select.value = value;
    });
  }

  function liveGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return document.getElementById('product-grid');
    return (
      container.querySelector('.collection:not(.collection--outgoing) #product-grid') ||
      container.querySelector('.collection:not(.collection--outgoing)') ||
      document.getElementById('product-grid')
    );
  }

  function finish(grid) {
    if (!grid) return;
    grid.removeAttribute('data-sort-pending');
    grid.dataset.sortReady = 'true';
  }

  async function apply() {
    const id = ++requestId;
    const grid = liveGrid();
    if (!grid) return;
    const params = new URLSearchParams(window.location.search);
    const chosen = params.get('sort_by');
    const source = grid.dataset.sourceCollection;

    if (!grid.querySelector('a[href*="/products/"]')) {
      if (id === requestId) finish(liveGrid() || grid);
      return;
    }

    if (source) {
      if (chosen && liquidSorts.has(chosen)) {
        finish(grid);
        return;
      }
      const sort = chosen || 'manual';
      const url = new URL(source, window.location.origin);
      url.searchParams.set('sort_by', sort);
      grid.dataset.sortPending = 'true';
      try {
        const response = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('status');
        const html = await response.text();
        if (id !== requestId) return;
        const current = liveGrid();
        if (current && current === grid) {
          const keys = keysFrom(html);
          if (keys.length) reorderGrid(current, keys);
          selectSort(sort);
        }
      } catch (error) {
        /* Keep the server-rendered order if the manual request fails. */
      }
      if (id === requestId) finish(liveGrid() || grid);
      return;
    }

    if (chosen) {
      finish(grid);
      return;
    }

    const fetchParams = new URLSearchParams(window.location.search);
    fetchParams.set('sort_by', 'manual');
    fetchParams.set('section_id', grid.dataset.id || '');
    grid.dataset.sortPending = 'true';
    try {
      const response = await fetch(`${window.location.pathname}?${fetchParams.toString()}`, {
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('status');
      const html = await response.text();
      if (id !== requestId) return;
      const current = liveGrid();
      if (current && current === grid) {
        const keys = keysFrom(html);
        if (keys.length) reorderGrid(current, keys);
        selectSort('manual');
      }
    } catch (error) {
      /* Keep the server-rendered order if the manual request fails. */
    }
    if (id === requestId) finish(liveGrid() || grid);
  }

  function boot() {
    if (window.FacetFiltersForm && !FacetFiltersForm.__featuredSortWrapped) {
      const original = FacetFiltersForm.renderProductGridContainer;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        const applied = original.call(FacetFiltersForm, html);
        if (applied) queueMicrotask(() => apply());
        return applied;
      };
      FacetFiltersForm.__featuredSortWrapped = true;
    }
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
